var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pbxmonitor"}},[_c('div',{attrs:{"id":"webheader"}},[_c('HeaderMonitor')],1),_c('div',{attrs:{"id":"webcontents"}},[_c('SearchMonitor'),_c('TableMonitor')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }